import React from 'react'
import { Divider, Select } from 'antd'
import { Project } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { CustomText, CustomSelect } from 'src/components'

const PurchaseBrokerageVintageSelector: React.FC<{ project: Project }> = ({ project }) => {
  const { t } = useTranslation()

  return <>
    {/* Vintage Years */}
    {(project && project.is_vintage) && <>
      {project.vintage_items.length === 0 ? <CustomText
        type='danger' label={t('admin.Brokerage.NonActive')}
      /> : <>
        <CustomText type='secondary' label={t('admin.Brokerage.YearRequest')}/>
        <CustomSelect
          name='vintageYear'
          placeholder={t('Projects.YearPlaceholder')}
          required
        >
          {project.vintage_items.map(v => <Select.Option
            key={v.year} value={v.year}>{v.year}
          </Select.Option>)}
        </CustomSelect>
        <Divider />
      </>}
    </>}
  </>
}

export default PurchaseBrokerageVintageSelector
